<template>
  <div>
    <div v-if="$store.state.user.attachBox.showing" class="attachment-dialog-cleed">
      <div class="attachment-card-cleed">
        <button class="attachment-close-cleed" @click="$store.state.user.attachBox.showing = false">
          <span class="material-icons">close</span>
        </button>
        <div class="attachment-row-cleed">
          <span class="material-icons" style="font-size: 24px; margin-right: 10px;">upload_file</span>
          <p class="attachment-card-title-cleed">
            {{ messages[$store.state.user.lang].title }}
          </p>
        </div>
        <br>
        <div class="attachment-card-text-cleed">
          <div class="attachment-row-cleed">
            <div class="attachment-col-cleed">
              <form enctype="multipart/form-data" style="margin: 0;" @submit.prevent="onButtonClick">
                <div class="attachment-form-control-cleed">
                  <div class="attachment-row-cleed">
                    <label for="fileInput" class="attachment-form-control-label-cleed">{{ messages[$store.state.user.lang].file_button }}</label>
                    <input 
                      id="fileInput" 
                      type="file" 
                      class="attachment-form-control-file-cleed" 
                      accept="image/png, image/jpeg, image/bmp" 
                      multiple 
                      label="File input"
                      placeholder="Select your files"
                      @change="uploadFile"
                    >
                    <button v-if="valid" class="attachment-form-control-button-cleed" @click="remove_images">
                      <span class="material-icons" style="font-size: 24px; margin-right: 10px;">delete_forever</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div v-if="fileInput.length > 0" class="attachment-card-text-cleed" style="display: flex; overflow-y: hidden; padding: 10px; overflow-x: scroll; margin-bottom: 3px;">
          <div v-for="(file, index) in fileInput" :key="index" class="attachment-col-part-cleed">
            <p class="attachment-col-part-cleed-text">
              <strong style="display: flex; align-items: center;">
                {{ file.name }}
                <button v-if="valid" class="attachment-form-control-button-cleed" @click="remove_image(index)">
                  <span class="material-icons" style="font-size: 24px; margin-right: 10px;">delete_forever</span>
                </button>
              </strong>
            </p>
          </div>
        </div>
        <span v-if="error" class="attachment-error-cleed">
          {{ error_message }}
        </span>
        <div class="attachment-card-actions-cleed">
          <div class="attachment-row-cleed">
            <button 
              class="attachment-submit-cleed"
              :disabled="!valid"
              color="black"
              @click="handleSubmit"
            >
              <strong>{{ messages[$store.state.user.lang].send_button }}</strong>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../utils';
import { customLogger } from "@/utils";

export default {
  name: 'AttachmentBox',
  data() {
    return {
      valid: false,
      fileInput: [],
      error: false,
      error_message: "",
      messages: {
        fr : {
          title: "Envoyer une pièce jointe",
          file_button: "Fichier(s)",
          send_button: "Envoyer les pièces jointes",
          error_format: "Le format de l'image n'est pas valide.",
          error_size: "La taille de l'image est trop grande.",
          error_upload: "Une erreur est survenue lors de l'envoi des images.",
          error_number: "Vous ne pouvez envoyer que 4 images maximum.",
        },
        en : {
          title: "Send an attachment",
          file_button: "File(s)",
          send_button: "Send attachments",
          error_format: "The image format is not valid.",
          error_size: "The image size is too large.",
          error_upload: "An error occurred while sending the images.",
          error_number: "You can only send 4 images maximum.",
        }
      }
    }
  },
  watch: {
    fileInput: {
      handler: function (val) {
        if (val.length > 0) {
          this.valid = true;
        } else {
          this.valid = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    remove_images() {
      this.fileInput = [];
      this.valid = false;
      this.error = false;
    },
    remove_image(index) {
      this.fileInput.splice(index, 1);
      if (this.fileInput.length === 0) {
        this.valid = false;
        this.error = false;
      }
    },
    async uploadFile(event) {
      if (event.target.files.length === 0) {
        this.fileInput = [];
        this.valid = false;
        return;
      }
      if (this.fileInput.length+1 > 4 || event.target.files.length > 4) {
        this.error = true;
        this.error_message = this.messages[this.$store.state.user.lang].error_number;
        return;
      }
      for (let i = 0; i < event.target.files.length; i++) {
        const element = event.target.files[i];
        if (!this.verifyImage(element)) {
          this.error = true;
          this.error_message = this.messages[this.$store.state.user.lang].error_format;
          return;
        }
        if (!this.verifyImageSize(element)) {
          this.error = true;
          this.error_message = this.messages[this.$store.state.user.lang].error_size;
          return;
        }
        this.error = false;
        this.fileInput.push(element);
      }
      this.valid = true;
      // customLogger(this.fileInput);
      // customLogger(this.valid);
    },
    handleSubmit() {
      // customLogger(this.valid);
      // customLogger("handleSubmit");
      const formData = new FormData();
      for (let i = 0; i < this.fileInput.length; i++) {
        const element = this.fileInput[i];
        formData.append("uploadedImages", element);
      }
      formData.append("guid", this.$store.state.user.guid);
      formData.append("conversation_id", this.$store.state.user.conversation_id);
      // this.loading = true;
      // this.$eb.emit("ChatSubmitMessage", formData, document.location.href);
      this.$store
        .dispatch("SEND_ATTACHMENTS", {
          formData,
          guid: this.$store.state.user.guid,
        })
        .then(() => {
          this.fileInput = [];
          this.$store.state.user.attachBox.showing = false;
          setTimeout(() => {
            customLogger("scrollDown");
            utils.scrollDown();
          }, 2000);
        })
        .catch((err) => {
          // this.loading = false;
          this.fileInput = [];
          this.error = true;
          this.error_message = this.messages[this.$store.state.user.lang].error_upload;
        });
    },
    verifyImage(file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (validTypes.indexOf(file.type) === -1) {
        return false;
      }
      return true;
    },
    verifyImageSize(file) {
      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        return false;
      }
      return true;
    },
  },
}

</script>
